/**
* @license Apache-2.0
*
* Copyright (c) 2021 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Compute the reciprocal square root for each element in a strided array `x` and assign the results to elements in a strided array `y`.
*
* @module @stdlib/math-strided-special-rsqrt
*
* @example
* var Float64Array = require( '@stdlib/array-float64' );
* var rsqrt = require( '@stdlib/math-strided-special-rsqrt' );
*
* var x = new Float64Array( [ 0.0, 4.0, 9.0, 12.0, 24.0 ] );
* var y = new Float64Array( [ 0.0, 0.0, 0.0, 0.0, 0.0 ] );
*
* rsqrt( x.length, 'float64', x, 1, 'float64', y, 1 );
* // y => <Float64Array>[ Infinity, 0.5, ~0.333, ~0.289, ~0.204 ]
*
* @example
* var Float64Array = require( '@stdlib/array-float64' );
* var rsqrt = require( '@stdlib/math-strided-special-rsqrt' );
*
* var x = new Float64Array( [ 0.0, 4.0, 9.0, 12.0, 24.0 ] );
* var y = new Float64Array( [ 0.0, 0.0, 0.0, 0.0, 0.0 ] );
*
* rsqrt.ndarray( x.length, 'float64', x, 1, 0, 'float64', y, 1, 0 );
* // y => <Float64Array>[ Infinity, 0.5, ~0.333, ~0.289, ~0.204 ]
*/

// MODULES //

var join = require( 'path' ).join;
var tryRequire = require( '@stdlib/utils-try-require' );
var javascript = require( './main.js' );


// MAIN //

var main;
var tmp = tryRequire( join( __dirname, './native.js' ) );
if ( tmp instanceof Error ) {
	main = javascript;
} else {
	main = tmp;
}


// EXPORTS //

module.exports = main;

// exports: { "ndarray": "main.ndarray" }
